import React,{useState,useEffect} from "react";
import Main from "../components/template/Main";
import { parse,format } from "date-fns"; 
import { useHistory,useParams } from "react-router-dom";
import { get,post } from "../store/config/register";
import { empresa_Id,login_Id } from "../store/config/dadosuser";
import { toast } from "react-toastify";
import TelefoneBrasileiroInput from "react-telefone-brasileiro";

const initialState ={
    agenda: {
      id: 0,
      responsavel: '',
      descricao: '',
      numero_convidado: '',
      celular_Responsavel: ''
    }
  }

  const headerProps = {
    icon: "calendar",
    title: "Agenda Dia",
  }

export default function ReservaAgendaDia() {
    const [horarios, setHorarios]=useState(undefined);
    const [horarioPadrao,setHorarioPadrao]= useState({})
    const [templateEmail,setTemplateEmail] = useState({});
    const [emailParam,setEmailParam]= useState({});
    const [agenda,setAgenda]=useState(initialState.agenda);
    const [espaco,setEspaco] = useState({});
    const [usuario,setUsuario] = useState({});

    const history = useHistory();
    const {id,data,horario}=useParams();
    let dataAgenda = parse(data,'dd-MM-yyyy',new Date());
    let diaSemana = dataAgenda.getDay()+1;

    useEffect(()=>{
        VerificaUsuario();
        buscaEspaco();
        buscaHorarioPadrao();
        BuscaTemplate(empresa_Id);
        BuscaEmailParam(empresa_Id);
        Horarios(diaSemana);
        buscaEspaco();
    },[])

    async function buscaHorarioPadrao() {
      const hors = await get('/EspacoPeriodoPadrao/v1/Espaco/'+ id);
      if(hors !== undefined){
       setHorarioPadrao(hors)
     }
     }

     async function buscaEspaco() {
      const esp = await get('/Espaco/v1/'+ id);
       if(esp !== undefined){
         setEspaco(esp)
        
       }
     }

    async function Horarios(diaSemana){
      const hors= await get(`/EspacoPeriodoHora/v1/Horarios?espaco_id=${id}&dia_semana=${diaSemana}`)

      if(hors.length > 0){
         //    hors.unshift({id: 0, hora_Inicio: '', hora_Fim: ''})

             setHorarios(hors)
         }
     }

    async function BuscaEmailParam(idEmpresa) {
        let result = await get('/ParamEmailResp/v1/'+idEmpresa);
        setEmailParam(result);
  
        return result;
    }

    async function buscaEspaco() {
        const esp = await get('/Espaco/v1/'+ id);
         if(esp !== undefined){
           setEspaco(esp)
          
         }
       }

       async function VerificaUsuario(){

        if(login_Id > 0){
          const  result = await  get(`/Login/v1/${login_Id}`);
          let unidade =result.unidade +' - '+ result.bloco+ ' - '+ result.nome
          setAgenda({...agenda, nome:unidade  })
            setUsuario(result)
       }
       
      }

      async function ExisteAgendamento(){
        let inicio="";
        if(horarios !== undefined){
             inicio=horarios.filter(f =>f.hora_Inicio === horario)[0].hora_Inicio
        }else {
            inicio =  horarioPadrao[0].hora_Inicio;
        }
        
       const res = await get('/EspacoAgenda/v1/Existe?espaco_id='+id+'&inicio='+ format(dataAgenda,"yyyy-MM-dd ")+inicio);
       return res.existe;
    }

    async function salvarReserva() {

          if(ValidaEvento()){
            let existe = await ExisteAgendamento();

          if(existe === false){
            let inicio= horario;        
            let dat ={ espaco_id: parseInt(id), unidade_id: usuario.unidade_Id,descricao: agenda.descricao, data: format(dataAgenda,"yyyy-MM-dd'T'")+inicio,hora_inicio: inicio,dia_semana: diaSemana, login_id: login_Id,numero_convidado: parseInt(agenda.numero_convidado === ''? '0': agenda.numero_convidado), celular_Responsavel: agenda.celular_Responsavel }  

            await post('/EspacoAgenda/v1',dat);
    
            if (espaco.termo) {
                await enviarEmail();
            }
            
            await toast.success('Agendamento realizado com sucesso.')
            history.push('/ReservaEspaco/'+id)
            window.location.reload();
          }else {
            await toast.warning('Já existe um agendamento para este horário');
          }
          }
          
 
        }

        function ValidaEvento(){
            if(espaco.flg_Celular_Responsavel && agenda.celular_Responsavel === ''){
               toast.warning('Celular não preenchido, este campo é obrigatório');
               return false;
            } 
          return true;
        }

    async function BuscaTemplate(idEmpresa){
        let result =await get('/Template/v1?tipo=6&empresa='+idEmpresa);
        setTemplateEmail(result);
        return result;
       }

       async function enviarEmail(Id){
        let emails =[];
        emails.push(emailParam.email);
       // emails.push('william@cisistemas.com.br');
         templateEmail.template =  templateEmail.template.replace('@unidade', `${usuario.unidade} - ${usuario.bloco}`); 
         templateEmail.template =  templateEmail.template.replace('@espaco', espaco.nome);
         templateEmail.template =  templateEmail.template.replace('@espaco', espaco.nome);    
         templateEmail.template =  templateEmail.template.replace('@nome', usuario.nome); 
         templateEmail.template =  templateEmail.template.replace('@data', `${format(dataAgenda,'dd/MM/yyyy')}`); 
         let data =  { sender:emails, subject: templateEmail.assunto,html: templateEmail.template,empresa_id: empresa_Id}

         let result = await post('/Email/v1',data);
        await toast.success('email enviado com sucesso');
      }

      function  updateField( event){
        const agen ={...agenda}
        agen[event.target.name] =event.target.value
        setAgenda(agen);
    }

       function renderForm(){
        return (
            <div className="form">
                <div className="nome-visitante">
                <div className="form-group">
                  <label>Responsável:</label>
                  <input type="text" name="responsavel" 
                  placeholder="Responsável" 
                    className="form-control" value={agenda.nome} 
                    onChange={e => updateField(e)} />
                </div>
            </div>

            {espaco.flg_Descricao_Evento  && (
                <div className="nome-visitante">
                <div className="form-group">
                  <label>Descrição de Evento:</label>
                  <input type="text" name="descricao" 
                  placeholder="Evento" 
                    className="form-control" value={agenda.descricao} 
                    onChange={e => updateField(e)} />
                </div>
            </div>
            )}
              {espaco.flg_Celular_Responsavel  && (
               <div className="nome-visitante">
                <div className="form-group">
                  <label>Celular:</label>
                  <TelefoneBrasileiroInput
                                    name="celular_Responsavel"
                                    className="form-control"
                                    temDDD={true}
                                  value={agenda.celular_Responsavel}
                                  placeholder="Celular" 
                                  onChange={e => updateField(e)}
                              />
                  </div>
            </div>
              )}
            {espaco.flg_Numero_Convidado === true && (
                <div className="nome-visitante">
                <div className="form-group">
                <label>Número de Convidados:</label>
                <input type="text" name="numero_convidado" 
                placeholder="Número de Convidados" 
                    className="form-control" value={agenda.numero_convidado} 
                    onChange={e => updateField(e)} />
                </div>
                </div>
            )}
           
            <br />
                    
              <button className="btn btn-primary " onClick={() => salvarReserva()}>Criar Reserva</button>  
            </div>
        );
       }



    return (
        <Main {...headerProps}>
            {renderForm()}
        </Main>
    );
}